import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Technology Version filter definition
 * Text input with contains/starts with operators
 * (Version values are too varied for dropdown)
 */
export const TechnologyVersion: SimpleFilterDefinition = {
  apiField: 'version',
  uiField: 'Version',
  inputType: 'text',
  operators: ['is'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Version',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: queryFilter.value as string,
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'version',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: simpleFilter.value,
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
